export default __webpack_public_path__ + "static/bg-tac--mobile-968eae1764d2c34bad85a2b0a95b38d9.jpg";